import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import redemptionErrorHandler from '~utils/redemption-error-handler.ts'
import { Redemption } from '~models/redemption'
import { mustBeValidVouchercode } from '~utils/validators'
import axios from '~plugins/axios'

enum State {
  Loading,
  Idle
}

export default Vue.extend({
  mixins: [validationMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data(): {
    state: State;
    voucherCode: string;
    errors: string[];
  } {
    return {
      state: State.Idle,
      voucherCode: '',
      errors: [],
    }
  },
  validations: {
    voucherCode: { required, mustBeValidVouchercode },
  },
  computed: {
    redemption(): Redemption {
      return this.$store.state.redemptions.redemption
    },
    loading(): boolean {
      return this.state === State.Loading
    },
  },
  methods: {
    async onSubmit() {
      this.errors = []
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      const payload = {
        voucherCode: this.voucherCode,
      }

      this.state = State.Loading
      try {
        const { data } = await axios.put(`/redemptions/${this.redemption.id}/voucher`, payload)
        this.$store.dispatch('redemptions/setRedemption', data)
        this.close()
      } catch (error) {
        this.errors = redemptionErrorHandler(error, this.$store.dispatch)
      } finally {
        this.state = State.Idle
      }
    },
    onModalInput(val: boolean) {
      if (!val) {
        this.close()
      } else {
        this.$emit('input', val)
      }
    },
    close() {
      this.errors = []
      this.voucherCode = ''
      this.$v.$reset()
      this.$emit('input', false)
    },
  },
})
